import { useTranslate } from '@growtherapy/i18n';
import { Button } from '@growtherapy/sprout-ui';

import { useContactUs } from '../../../useContactUs';

export function ContactSupportButton() {
  const t = useTranslate();
  const { directFormUrl } = useContactUs();
  return (
    <Button
      onClick={() => {
        window.open(directFormUrl, '_blank');
      }}
    >
      {t('telehealth-core:core.contactSupport')}
    </Button>
  );
}
